export default __webpack_public_path__ + "static/media/avatar.038a81d1.svg";